export const DUPLICATED_TAB_RECOVERY_SESSION_KEY = "duplicatedTabRecoveryReload";

let reloadScheduled = false;

export function consumeShouldReloadRestoredTab(input: {
  alreadyReloaded: boolean;
  navigationType?: string;
  persisted?: boolean;
}): boolean {
  if (input.alreadyReloaded) {
    return false;
  }

  return input.persisted === true || input.navigationType === "back_forward";
}

export function readDuplicatedTabRecoveryFlag(): boolean {
  try {
    if (typeof sessionStorage === "undefined") {
      return false;
    }

    return sessionStorage.getItem(DUPLICATED_TAB_RECOVERY_SESSION_KEY) === "1";
  } catch {
    return false;
  }
}

export function markDuplicatedTabRecoveryReloaded(): void {
  try {
    if (typeof sessionStorage === "undefined") {
      return;
    }

    sessionStorage.setItem(DUPLICATED_TAB_RECOVERY_SESSION_KEY, "1");
  } catch {
    // Private-mode or blocked storage must not prevent the one-shot in-memory reload.
  }
}

export function clearDuplicatedTabRecoveryFlag(): void {
  try {
    if (typeof sessionStorage === "undefined") {
      return;
    }

    sessionStorage.removeItem(DUPLICATED_TAB_RECOVERY_SESSION_KEY);
  } catch {
    // Ignore storage failures; in-memory reloadScheduled still guards loops.
  }
}

export function takeDuplicatedTabReloadDecision(input: {
  navigationType?: string;
  persisted?: boolean;
}): boolean {
  if (reloadScheduled) {
    return false;
  }

  if (readDuplicatedTabRecoveryFlag()) {
    clearDuplicatedTabRecoveryFlag();
    return false;
  }

  const shouldReload = consumeShouldReloadRestoredTab({
    alreadyReloaded: false,
    navigationType: input.navigationType,
    persisted: input.persisted,
  });

  if (!shouldReload) {
    return false;
  }

  reloadScheduled = true;
  markDuplicatedTabRecoveryReloaded();
  return true;
}

export function getNavigationType(): string | undefined {
  if (typeof performance === "undefined" || typeof performance.getEntriesByType !== "function") {
    return undefined;
  }

  const navigation = performance.getEntriesByType("navigation")[0] as
    | PerformanceNavigationTiming
    | undefined;

  return navigation?.type;
}

export function resetDuplicatedTabReloadScheduleForTests(): void {
  reloadScheduled = false;
}
